import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import styles from './index.module.scss';
import classnames from "classnames";

interface IProps {
  rootElementId?: string;
  show: boolean;
  setShow?: Function;
  conf: {
    title?: string;
    btns: Array<{
      id: 'cancel' | 'submit';
      text: string;
      callback?: Function;
    }>;
  };
  children?: any;
}

const NoticeDialog = (props: IProps): React.ReactElement => {
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    setShowDialog(props.show);
  }, [props.show]);

  return ReactDOM.createPortal(
    <>
      {showDialog &&
        <div className={styles.noticeDialogLayer}>
          <div className={styles.noticeDialogInner}>
            <div className={styles.noticeDialogContent}>{props.children}</div>
            <div className={styles.noticeDialogBtnGroup}>
              {
                props.conf.btns.map(btn => {
                  return <button
                    key={btn.id}
                    className={classnames(styles.noticeDialogBtn, {
                      [styles.cancelBtn]: btn.id == 'cancel',
                      [styles.submitBtn]: btn.id == 'submit'
                    })}
                    onClick={() => { btn.callback && btn.callback() }}>{btn.text}</button>
                })
              }
            </div>
          </div>
        </div>}
    </>,
    (document.getElementById(props.rootElementId || 'homeRightContent') || document.body)
  );
}

export default NoticeDialog;


